import React, { Component } from "react";

class RevvForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialFormValue: props.initialFormValue,
      values: props.initialFormValue,
      validateOnChange: props.validateOnChange,
      validateOnBlur: true,
      customFieldName: props.customFieldName,
      customFieldComponentRules: props.customFieldComponentRules,
      customFieldComponentMessages: props.customFieldComponentMessages,
      errors: {},
      messages: {},
      touched: {},
      isValid: false,
    };
  }

  componentDidMount() {
    const touched = {};
    const { initialFormValue, customFieldComponentRules, customFieldName } =
      this.state;
    if (initialFormValue && Object.keys(initialFormValue).length) {
      Object.keys(initialFormValue).forEach(key => {
        if (
          (initialFormValue[key] !== "" ||
            (initialFormValue[key] === "" &&
              (!Object.prototype.hasOwnProperty.call(
                customFieldComponentRules[customFieldName],
                key,
              ) ||
                (Object.prototype.hasOwnProperty.call(
                  customFieldComponentRules[customFieldName],
                  key,
                ) &&
                  !Object.prototype.hasOwnProperty.call(
                    customFieldComponentRules[customFieldName][key],
                    "required",
                  ))))) &&
          !Array.isArray(initialFormValue[key])
        ) {
          touched[key] = true;
        }
      });
    }
    this.setState({ touched });
    // this.setState({ touched }, () => console.debug(this.state));
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.initialFormValue) !==
      JSON.stringify(this.props.initialFormValue)
    ) {
      this.setState({
        // eslint-disable-next-line no-nested-ternary
        values: this.props.initialFormValue
          ? JSON.parse(JSON.stringify(this.props.initialFormValue))
          : JSON.parse(JSON.stringify(prevProps.initialFormValue)),
      });
    }
  }

  validateList = (fieldName, value, index) => {
    const {
      values,
      customFieldName,
      customFieldComponentRules,
      customFieldComponentMessages,
      errors,
      messages,
      touched,
    } = this.state;

    // In case there is no rule defined for the custom rule
    if (customFieldComponentRules[customFieldName][fieldName] === undefined) {
      const isValid = Object.keys(errors).length === 0;
      this.setState({ errors, isValid, messages });
      return;
    }
    Object.keys(customFieldComponentRules[customFieldName][fieldName]).forEach(
      ruleName => {
        if (
          !customFieldComponentRules[customFieldName][fieldName][ruleName]({
            value,
            values,
          })
        ) {
          if (!(fieldName in errors)) {
            errors[fieldName] = [];
          }
          if (!(fieldName in messages)) {
            messages[fieldName] = {};
            messages[fieldName][ruleName] = [];
          }
          errors[fieldName][index] = true;

          messages[fieldName][ruleName][index] =
            customFieldComponentMessages[customFieldName][fieldName][ruleName];
        } else {
          if (
            errors[fieldName] !== undefined &&
            errors[fieldName] &&
            errors[fieldName][index] !== undefined
          ) {
            errors[fieldName][index] = false;
          }
          if (
            messages[fieldName] !== undefined &&
            messages[fieldName][ruleName] !== undefined &&
            messages[fieldName][ruleName].length > 0 &&
            messages[fieldName][ruleName][index] !== undefined
          ) {
            messages[fieldName][ruleName][index] = "";

            if (Object.keys(messages[fieldName]).length === 0) {
              delete messages[fieldName];
            }
          }
        }
      },
    );

    // For the form to be valid every key in 'values' should be 'touched' and no errors should be presents
    let isValid = Object.keys(errors).length === 0;
    const valueKeys = Object.keys(values);
    const touchedKeys = Object.keys(touched);
    const difference = valueKeys.filter(x => !touchedKeys.includes(x));
    isValid = isValid && difference.length === 0;
    this.setState({ errors, isValid, messages });
  };

  validate = (fieldName, value) => {
    const {
      values,
      customFieldName,
      customFieldComponentRules,
      customFieldComponentMessages,
      errors,
      messages,
      touched,
    } = this.state;
    // In case there is no rule defined for the custom rule
    if (customFieldComponentRules[customFieldName][fieldName] === undefined) {
      return;
    }

    Object.keys(customFieldComponentRules[customFieldName][fieldName]).forEach(
      ruleName => {
        if (
          !customFieldComponentRules[customFieldName][fieldName][ruleName]({
            value,
            values,
          })
        ) {
          errors[fieldName] = true;
          if (messages[fieldName] === undefined) {
            messages[fieldName] = {};
          }
          messages[fieldName][ruleName] =
            customFieldComponentMessages[customFieldName][fieldName][ruleName];
        } else {
          if (errors[fieldName] !== undefined && errors[fieldName]) {
            delete errors[fieldName];
          }
          if (
            messages[fieldName] !== undefined &&
            messages[fieldName][ruleName] !== undefined &&
            messages[fieldName][ruleName].length > 0
          ) {
            delete messages[fieldName][ruleName];

            if (Object.keys(messages[fieldName]).length === 0) {
              delete messages[fieldName];
            }
          }
        }
      },
    );

    // For the form to be valid every key in 'values' should be 'touched' and no errors should be presents
    let isValid = Object.keys(errors).length === 0;
    const valueKeys = Object.keys(values);
    const touchedKeys = Object.keys(touched);
    const difference = valueKeys.filter(x => !touchedKeys.includes(x));
    isValid = isValid && difference.length === 0;
    this.setState({ errors, isValid, messages });
  };

  handleBlur = event => {
    const { touched, validateOnBlur } = this.state;
    touched[event.target.name] = true;
    this.setState({ touched });
    if (validateOnBlur) {
      this.validate(event.target.name, event.target.value);
    }
  };

  handleBlurByName = (event, name) => {
    const { touched, validateOnBlur } = this.state;
    touched[name] = true;
    this.setState({ touched });
    if (validateOnBlur) {
      this.validate(name, event);
    }
  };

  handleChangeByName = (event, name) => {
    const { values, validateOnChange, touched } = this.state;
    touched[name] = true;
    values[name] = event;
    this.setState({ values, touched });
    if (validateOnChange) {
      this.validate(name, event);
    }
  };

  handleChange = event => {
    const { values, validateOnChange, touched, customFieldName } = this.state;
    const { transformFieldValue } = this.props;
    const newValues = { ...values };
    const newTouched = { ...touched };
    if (
      typeof event === "number" ||
      event === "" ||
      (typeof event === "string" && event.indexOf(".") > 0)
    ) {
      newTouched.default = true;
      newValues.default = event;
    } else {
      newTouched[event.target.name] = true;

      const newVal =
        transformFieldValue[customFieldName] &&
        transformFieldValue[customFieldName][event.target.name]
          ? transformFieldValue[customFieldName][event.target.name]({
              value: event.target.value,
            })
          : event.target.value;
      newValues[event.target.name] = newVal;
    }

    this.setState({ values: newValues, touched: newTouched });
    if (event.target && event.target.name) {
      if (validateOnChange) {
        this.validate(event.target.name, event.target.value);
        // transform - rules
      }
    }
  };

  handleChangeInList = (event, index) => {
    let eventValue = event.target.value;
    if (event.target.type === "checkbox") {
      eventValue = event.target.checked;
    }

    const { values, validateOnChange, touched } = this.state;
    if (!(event.target.name in touched)) {
      touched[event.target.name] = [];
    }
    touched[event.target.name][index] = true;
    values[event.target.name][index] = eventValue;
    this.setState({ values });
    if (validateOnChange) {
      this.validateList(event.target.name, eventValue, index);
    }
  };

  handleRemoveFromList = (name, index) => {
    const {
      values,
      touched,
      messages,
      errors,
      customFieldComponentRules,
      customFieldName,
    } = this.state;

    values[name].splice(index, 1);

    if (name in touched) touched[name].splice(index, 1);
    if (name in errors) errors[name].splice(index, 1);

    if (name in customFieldComponentRules[customFieldName]) {
      Object.keys(customFieldComponentRules[customFieldName][name]).forEach(
        ruleName => {
          if (name in messages) {
            if (ruleName in messages[name]) {
              messages[name][ruleName].splice(index, 1);

              if (messages[name][ruleName].length === 0) {
                delete messages[name][ruleName];
              }
            }
          }
        },
      );
    }

    this.setState({ values, errors, touched, messages });
  };

  handleAddToList = (name, value) => {
    const { values } = this.state;
    values[name].push(value);
    this.setState({ values });
  };

  render() {
    const {
      initialFormValue,
      values,
      touched,
      errors,
      messages,
      validateOnBlur,
      validateOnChange,
      isValid,
    } = this.state;

    return (
      <React.Fragment>
        <div id={`revvForm${this.props.revvFormId}`}>
          {this.props.render({
            initialFormValue,
            values,
            handleChange: this.handleChange,
            handleChangeByName: this.handleChangeByName,
            handleBlurByName: this.handleBlurByName,
            handleBlur: this.handleBlur,
            handleChangeInList: this.handleChangeInList,
            handleRemoveFromList: this.handleRemoveFromList,
            handleAddToList: this.handleAddToList,
            touched,
            errors,
            messages,
            validateOnBlur,
            validateOnChange,
            isValid,
          })}
        </div>
      </React.Fragment>
    );
  }
}

RevvForm.defaultProps = {
  transformFieldValue: {},
};

export default RevvForm;
